import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
import { NairobiAtGlance } from '../components/NairobiAtGlance';
export function AboutNairobiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const stats = [{
    label: 'Population',
    value: '4.8M+'
  }, {
    label: 'Elevation',
    value: '1,795m'
  }, {
    label: 'Founded',
    value: '1899'
  }, {
    label: 'Area',
    value: '696 km²'
  }];
  const timeline = [{
    year: '1899',
    title: 'Railway Camp',
    description: 'Nairobi established as railway depot for Uganda Railway'
  }, {
    year: '1907',
    title: 'Colonial Capital',
    description: 'Replaced Mombasa as capital of British East Africa'
  }, {
    year: '1963',
    title: 'Independence',
    description: 'Kenya gains independence; Nairobi becomes national capital'
  }, {
    year: '2010',
    title: 'New Constitution',
    description: 'Nairobi becomes one of 47 counties under new governance'
  }, {
    year: 'Today',
    title: 'Regional Hub',
    description: "East Africa's economic and diplomatic powerhouse"
  }];
  return <div className="min-h-screen bg-white" data-id="element-332">
      {/* Hero - Text Only */}
      <div className="border-b border-gray-200" data-id="element-333">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 md:py-32" data-id="element-334">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-4xl" data-id="element-335">
            <div className="h-px w-16 bg-amber-500 mb-8" data-id="element-336"></div>
            <h1 className="text-7xl md:text-9xl font-light text-gray-900 mb-6 leading-[0.9] tracking-tight" data-id="element-337">
              About
              <br data-id="element-338" />
              <span className="font-serif italic" data-id="element-339">Nairobi</span>
            </h1>
            <p className="text-2xl md:text-3xl text-gray-600 leading-relaxed font-light max-w-2xl" data-id="element-340">
              The Green City in the Sun. Where Africa's wild heart meets refined
              sophistication.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20" data-id="element-341">
        {/* Stats */}
        <section className="mb-20" data-id="element-342">
          <div className="h-px w-12 bg-amber-500 mb-6" data-id="element-343"></div>
          <h2 className="text-3xl font-light text-gray-900 mb-8 tracking-tight" data-id="element-344">
            At a Glance
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-345">
            {stats.map((stat, index) => <motion.div key={stat.label} className="p-6 border border-gray-200" initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: index * 0.1
          }} data-id="element-346">
                <div className="text-4xl font-light text-gray-900 mb-2" data-id="element-347">
                  {stat.value}
                </div>
                <div className="text-xs text-gray-600 uppercase tracking-widest font-light" data-id="element-348">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Introduction */}
        <section className="mb-20" data-id="element-349">
          <div className="max-w-4xl mx-auto" data-id="element-350">
            <div className="h-px w-16 bg-amber-500 mb-8 mx-auto" data-id="element-351"></div>
            <h2 className="text-5xl font-light text-gray-900 mb-10 tracking-tight text-center" data-id="element-352">
              The City
            </h2>
            <div className="space-y-6 text-gray-700 text-xl leading-relaxed font-light" data-id="element-353">
              <p className="text-center" data-id="element-354">
                Nairobi is a city of contrasts and contradictions, where
                gleaming skyscrapers stand alongside sprawling informal
                settlements, where lions roam just kilometers from the central
                business district, and where ancient traditions blend seamlessly
                with cutting-edge innovation.
              </p>
              <p className="text-center" data-id="element-355">
                Founded in 1899 as a railway depot, Nairobi has grown into East
                Africa's most important economic and cultural hub. The city
                serves as the regional headquarters for numerous international
                organizations and multinational corporations.
              </p>
              <p className="text-center" data-id="element-356">
                With a population exceeding 4.8 million, Nairobi is Kenya's
                largest city and one of Africa's major metropolitan areas.
                Despite rapid urbanization, the city has maintained significant
                green spaces, including the unique Nairobi National Park.
              </p>
            </div>
          </div>
        </section>

        {/* Essential Information */}
        <section className="mb-20" data-id="element-357">
          <div className="max-w-5xl mx-auto" data-id="element-358">
            <div className="h-px w-16 bg-amber-500 mb-8 mx-auto" data-id="element-359"></div>
            <h2 className="text-5xl font-light text-gray-900 mb-12 tracking-tight text-center" data-id="element-360">
              Essential Information
            </h2>
            <NairobiAtGlance data-id="element-361" />
          </div>
        </section>

        {/* Timeline */}
        <section className="mb-20" data-id="element-362">
          <div className="max-w-4xl mx-auto" data-id="element-363">
            <div className="h-px w-16 bg-amber-500 mb-8 mx-auto" data-id="element-364"></div>
            <h2 className="text-5xl font-light text-gray-900 mb-16 tracking-tight text-center" data-id="element-365">
              Historical Journey
            </h2>
            <div className="space-y-0" data-id="element-366">
              {timeline.map((event, index) => <motion.div key={event.year} className="flex gap-8 py-10 border-b border-gray-200 last:border-0" initial={{
              x: -20,
              opacity: 0
            }} animate={{
              x: 0,
              opacity: 1
            }} transition={{
              delay: index * 0.1
            }} data-id="element-367">
                  <div className="w-32 flex-shrink-0" data-id="element-368">
                    <span className="text-4xl font-light text-gray-900" data-id="element-369">
                      {event.year}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-370">
                    <h3 className="text-2xl font-light text-gray-900 mb-3" data-id="element-371">
                      {event.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed font-light text-lg" data-id="element-372">
                      {event.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </section>
      </div>

      <ScrollToTop data-id="element-373" />
      <Footer data-id="element-374" />
    </div>;
}